import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { CookiesProvider } from "react-cookie";
import ErrorBoundary from './ErrorBoundary';

const rootElement = document.getElementById('root');

const renderApp = () => {
    return (ReactDOM.render(
        <CookiesProvider>
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </CookiesProvider>,
        rootElement));
}
renderApp();